// extracted by mini-css-extract-plugin
module.exports = {"window":"Popup_window__1z49V","showWindow":"Popup_showWindow__16XCl","window__close":"Popup_window__close__3ioZg","disabled":"Popup_disabled__276oZ"};